if (!customElements.get('cart-discount-code')) {
  class CartDiscountCode extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-discount-input]');
      this.button = this.querySelector('[data-discount-apply]');
      this.error = this.querySelector('[data-discount-error]');

      this.button.addEventListener('click', () => this.apply());
      this.input.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.apply();
      });
      this.input.addEventListener('input', () => this.hideError());
      this.querySelectorAll('[data-discount-remove]').forEach(button => {
        button.addEventListener('click', () => this.remove(button.dataset.discountRemove));
      });
    }

    get appliedCodes() {
      return (this.dataset.appliedCodes || '')
        .split(',')
        .map(code => code.trim())
        .filter(Boolean);
    }

    apply() {
      const code = this.input.value.trim();
      if (!code) {
        this.input.focus();
        return;
      }
      const previous = this.appliedCodes;
      const codes = previous.filter(c => c.toLowerCase() !== code.toLowerCase()).concat(code);

      this.setLoading(true);
      this.request(codes.join(','))
        .then(cart => {
          if (this.isApplied(cart, code)) {
            this.renderSections(cart);
            return;
          }
          this.showError();
          return this.request(previous.join(','), false);
        })
        .catch(() => this.showError())
        .finally(() => this.setLoading(false));
    }

    remove(code) {
      const codes = this.appliedCodes.filter(c => c.toLowerCase() !== code.toLowerCase());
      this.setLoading(true);
      this.request(codes.join(','))
        .then(cart => this.renderSections(cart))
        .finally(() => this.setLoading(false));
    }

    request(discount, withSections = true) {
      const sections = this.sections();
      const body = { discount };
      if (withSections && sections.length) {
        body.sections = sections.map(section => section.section);
        body.sections_url = window.location.pathname;
      }
      return fetch(routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(response => response.json());
    }

    sections() {
      return typeof sectionsToRender !== 'undefined' && Array.isArray(sectionsToRender) ? sectionsToRender : [];
    }

    isApplied(cart, code) {
      const wanted = code.toLowerCase();
      if (Array.isArray(cart.discount_codes)) {
        const entry = cart.discount_codes.find(item => (item.code || '').toLowerCase() === wanted);
        return Boolean(entry && entry.applicable);
      }
      const titles = (cart.cart_level_discount_applications || []).map(item => item.title);
      (cart.items || []).forEach(item => {
        (item.line_level_discount_allocations || []).forEach(allocation => {
          if (allocation.discount_application) titles.push(allocation.discount_application.title);
        });
      });
      return titles.some(title => (title || '').toLowerCase() === wanted);
    }

    renderSections(cart) {
      if (!cart.sections) return;
      this.sections().forEach(section => {
        const html = cart.sections[section.section];
        if (!html) return;
        const target = document.querySelector(section.selector) || document.querySelector(section.id);
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (target && source) target.innerHTML = source.innerHTML;
      });
      if (typeof handleCartInputNames === 'function') handleCartInputNames();
    }

    setLoading(state) {
      this.classList.toggle('is-loading', state);
      this.button.disabled = state;
      this.input.disabled = state;
    }

    showError() {
      this.error.hidden = false;
      this.input.setAttribute('aria-invalid', 'true');
      this.input.focus();
    }

    hideError() {
      this.error.hidden = true;
      this.input.removeAttribute('aria-invalid');
    }
  }

  customElements.define('cart-discount-code', CartDiscountCode);
}
